<template>
    <div>
        <div class="q-gutter-md" v-if="mockData">
            <div class="select-unique-navbar row justify-center items-center" @click="openListNavbar()">
                <span class="text-weight-bold q-pr-sm">{{ !lendingPoint ? $T('select one') : mockData.find(item => item.value === lendingPoint).label }}</span>
                <q-icon :class="showListNavbar ? 'rotate' : 'not-rotate'" name="fa icon-chevron-down"></q-icon>
                <q-popover @hide="showListNavbar = false" id="popover-select-navbar" ref="popover_select_navbar" anchor="bottom middle" self="top middle">
                    <q-input
                        class="input-filter"
                        v-model="lendingPointSearchInput"
                        :placeholder="$T('filter')"
                        :before="[{
                            icon: 'fa icon-search',
                        }]"
                    />
                    <q-scroll-area :style="isMobile ? 'width:100vw;height:calc(100vh - 89px);' : 'width:30vw;height:44vh;'">
                        <q-list class="list-select" no-border>
                            <q-item v-for="item in lendingPointsList" :key="item.value">
                                <q-item-main :label="item.label" @click.native="setLendingPoint(item.value)" />
                            </q-item>
                        </q-list>
                    </q-scroll-area>
                </q-popover>
            </div>

            <!-- <label  v-if="useLabel">{{$T('lending points')}}</label> -->
            <!-- <q-select
                id="lendingPointSelect"
                v-model="lendingPoint"
                filter
                :options="mockData"
                @focus="rotate('rotate')"
                @blur="rotate('default')"
                @input="setLendingPoint(lendingPoint)" /> -->
            <q-dialog
                    v-model="customDialogModel"
                    prevent-close
                    @ok="onOk"
                    @cancel="onCancel"
                    @show="onShow"
                    @hide="onHide"
            >

                <span class="text-weight-bold" slot="title">
                     <div class="row justify-end">
                        <q-icon name="fa icon-close cursor-pointer" @click.native="closeCustomDialog"/>
                     </div>
                     <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                        {{$T('switch lending point')}}
                        <hr class="q-mt-sm q-mb-xl modal-hr" width="100%">
                     </div>
                </span>

                <span class="text-center" slot="message">
                      <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                         <span v-html="message" style="color: #34303D;"></span>
                     </div>
                </span>

                <template slot="buttons" slot-scope="props">
                    <div :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'" class="items-center">
                        <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" class="capitalize" outline rounded color="primary" :label="$t('cancel')" @click="props.cancel" />
                        <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" class="capitalize" color="highlight" text-color="primary" rounded :label="$t('yes')" @click="choose()" />
                    </div>
                </template>
            </q-dialog>

            <!-- After Login Modal -->
            <q-dialog
                    class="style-modal"
                    v-model="chooseLoginLendingPoint"
                    prevent-close
                    :ok="false"
                    @show="onShow"
                    @hide="onHide"
                    ref="modal"
            >
                    <span class="text-weight-bold" slot="title">
                        <div class="row justify-end">
                            <q-icon name="fa icon-close cursor-pointer" @click.native="chooseLoginLendingPoint = false"/>
                        </div>
                         <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                            {{$T('select a point of sale to continue')}}
                            <hr class="q-mt-sm q-mb-xl modal-hr" width="98%">
                        </div>
                    </span>
                    <div slot="body" :style="!showList ? 'margin-bottom:20px' : ''">
                        <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                            <div class="select-unique row justify-between items-center" @click="openList">
                                <span>{{ !lendingPointLogin ? $T('select one') : mockData.find(item => item.value === lendingPointLogin).label}}</span>
                                <q-icon v-if="showIconDropdown" :class="showList ? 'rotate' : 'not-rotate'" name="fa icon-chevron-down"></q-icon>
                                <img v-if="showOkImg" src="./../../img/ok-form.svg" width="24px" height="24px" />
                            </div>
                            <div v-show="showList" class="content-list">
                                <q-input 
                                    class="input-filter"
                                    v-model="lendingPointLoginSearchInput"
                                    :placeholder="$T('filter')"
                                    :before="[{
                                        icon: 'fa icon-search',
                                    }]"
                                />
                                <q-scroll-area ref="scroll" class="select-punto" :style="{height:scrollHeight + 'px'}">
                                    <q-list class="list-select" no-border>
                                        <q-item v-for="item in lendingPointsLoginList" :key="item.value">
                                            <q-item-main :label="item.label" @click.native="setLendingPointLogin(item.value)" />
                                        </q-item>
                                    </q-list>
                                </q-scroll-area>
                            </div>
                        </div>
                    </div>
            </q-dialog>

            <!-- Geolocation Modal -->
            <q-dialog
                class="style-modal"
                v-model="geolocationModal"
                prevent-close
                ref="modal"
            >
                    <span class="text-weight-bold" slot="title">
                        <div class="row justify-end">
                            <q-icon name="fa icon-close cursor-pointer" @click.native="closeGeoLocationModal"/>
                        </div>
                         <div class="column items-center" :class="isMobile ? '' : 'dialog-padding'">
                            {{ $T('are you in lending point')}}
                             <br>
                             {{ geoLocationLendingPoint.description + '?'}}
                            <hr class="q-mt-sm q-mb-xl modal-hr" width="98%">
                        </div>
                    </span>
                    <template slot="buttons" slot-scope="props">
                        <div :class="isMobile ? 'column reverse half-width justify-between' : 'row full-width justify-around q-mb-lg dialog-padding'" class="items-center">
                            <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" class="capitalize" outline rounded color="primary" :label="$t('no')" @click="closeGeoLocationModal()" />
                            <q-btn size="md" :class="isMobile ? 'q-mb-md full-width' : 'col-3'" class="capitalize" color="highlight" text-color="primary" rounded :label="$t('yes')" @click="setGeolocationLendingPoint()" />
                        </div>
                    </template>
            </q-dialog>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import {
        QSelect,
        QDialog,
        QCard,
        QBtn,
        QField
    } from 'quasar-framework'
    import axios from "axios";

    export default {
        name: "dropdownLendingPoint",
        props:{
            useLabel: {
                type: Boolean
            }
        },

        computed: {
            ...mapGetters({
                user: 'auth/user',
                token: 'auth/token'
            }),

            lendingPointsList() {
                if (!this.lendingPointSearchInput.trim()) return this.mockData
                return this.mockData.filter((item) => {
                    if (item.label.toLowerCase().includes(this.lendingPointSearchInput.toLowerCase())) {
                        return item
                    }
                })
            },

            lendingPointsLoginList() {
                if (!this.lendingPointLoginSearchInput.trim()) return this.mockData
                return this.mockData.filter((item) => {
                    if (item.label.toLowerCase().includes(this.lendingPointLoginSearchInput.toLowerCase())) {
                        return item
                    }
                })
            }
        },

        data () {
            return {
                lendingPoint            : null,
                mockData                : [],
                customDialogModel       : false,
                chooseLoginLendingPoint : false,
                name                    : '',
                filterLendingPoint      : null,
                search                  : '',
                lendingPointLogin       : null,
                message                 : '',
                isMobile: true,
                showList: false,
                showListNavbar: false,
                showOkImg: false,
                showIconDropdown: true,
                lendingPointSearchInput: '',
                lendingPointLoginSearchInput: '',
                scrollHeight: 1000,
                geolocationModal: false,
                geoLocationClientID: null,
                geoLocationSecret: null,
                geoLocationEndpoint: null,
                geoLocationToken: '',
                geoLocationLendingPoint: {id: null, description: ''}
            }
        },

        mounted() {
            this.isMobile = this.$q.platform.is.mobile
            //this.isEligibleLendingPoint()
            this.getGeoLocationConfig()
            this.canRequestGeolocation()
            this.getMockData()
        },

        components: {
            QSelect,
            QDialog,
            QCard,
            QBtn,
            QField
        },

        watch: {
            showList(){
                this.$nextTick(() => {
                    if(this.showList){
                        const padding = 50
                        const modalHeight = this.$refs.modal.$refs.modal.$refs.content.offsetHeight
                        const scrollTop = this.$refs.scroll.$el.offsetTop
                        this.scrollHeight = modalHeight - scrollTop - padding
                    } else {
                        this.scrollHeight = 1000
                    }
                })
            }
        },

        methods: {
            async getMockData() {
                const {data}       = await axios.get(`${config.appUrl}/api/v1/get-lending-points`)
                this.mockData      = data.data
                this.lendingPoint  = data.lendingPoint
            },

            setLendingPoint(lendingPointKey) {
                if (lendingPointKey) {
                    this.lendingPoint = lendingPointKey
                    this.getMessageLendingPoint()
                    this.customDialogModel = true
                    this.$refs.popover_select_navbar.hide()
                    this.showListNavbar = false
                }
            },

            async isEligibleLendingPoint() {
                const {data} = await axios.get(`${config.appUrl}/api/v1/get-lending-selector`)
                if (data.success == "true") {
                    this.chooseLoginLendingPoint = true
                }
            },

            openList(){
                this.showList = !this.showList
            },

            openListNavbar() {
                this.showListNavbar = !this.showListNavbar
            },

            getMessageLendingPoint() {
                let LP = '';
                let LPId = 0;
                if (this.lendingPointLogin != undefined ) {
                    LPId = this.lendingPointLogin
                } else {
                    LPId = this.lendingPoint
                }

                this.mockData.map(function (row) {
                    if (row.value == LPId) {
                        LP = row.label
                    }
                })

                this.message = this.$_T('are you sure that desire switch the lending point to <br/><strong>:pos_name</strong>?', {pos_name: LP})
            },

            onOk (data) { },

            // when props.cancel() gets called
            onCancel () {
                this.lendingPoint = this.user.lending_point_id
                this.showOkImg = !!this.lendingPointLogin
                this.showIconDropdown = !this.lendingPointLogin
            },

            // when we show it to the user
            onShow () { },

            // when it gets hidden
            onHide () { },

            // custom handler
            async choose () {
                if (this.lendingPoint.length === 0) {
                    this.$q.dialog({
                        title: 'Please specify one Lending Point!'
                    })
                }
                else {
                    let lendingP =  this.lendingPointLogin != undefined ? this.lendingPointLogin : this.lendingPoint
                    await axios.post(`${config.appUrl}/api/v1/set-lending-point`, {lendingPoint : lendingP}).then(function() {
                       location.href = `${config.appUrl}/home?token=${this.token}`
                    }.bind(this))
                }
            },

            setLendingPointLogin(lendingPoint) {
                if (!lendingPoint) return false
                this.lendingPointLogin = lendingPoint
                this.getMessageLendingPoint()
                setTimeout(() => {
                    this.customDialogModel = true
                }, 1000);
                this.showList = false
                this.showOkImg = !!this.lendingPointLogin
                this.showIconDropdown = !this.lendingPointLogin
            },

            closeCustomDialog() {
                this.lendingPoint = this.user.lending_point_id
                this.customDialogModel = false
            },

            getGeoLocationConfig() {
                if (config.appName.includes('QA')) {
                    this.geoLocationClientID = 4
                    this.geoLocationSecret = 'bO7o7qqss5ou11rQcMz0drzyrkBkGQW47Zg6IGCZ'
                    this.geoLocationEndpoint = 'https://scan-pack.qa.iqoscare.es/'
                } else {
                    this.geoLocationClientID = 3
                    this.geoLocationSecret = 'Tpuzi6XLFp8l1hAFYhsPiNXa0x6NiSyJVFxFax8Q'
                    this.geoLocationEndpoint = 'https://scan-pack.iqoscare.es/'
                }
            },

            canRequestGeolocation() {
                return false
                axios.get(`${config.appUrl}/api/v1/can-request-geolocation`).then(response => {
                    if (response.data.success == "true") {
                        this.requestUserLocation()
                    }
                })
            },

            requestUserLocation() {
                window.navigator.geolocation.getCurrentPosition(location => {
                    //console.log('Request location')
                    //console.log(location)
                    if (location) {
                        if (!this.geoLocationToken) {
                            this.requestGeoLocationToken(location)
                        } else {
                            this.checkUserLocation(location)
                        }
                    }
                }, failure => {
                    //console.log(failure)
                })
            },

            requestGeoLocationToken(location) {
                //console.log('Request token')
                //console.log(location)
                axios.post(this.geoLocationEndpoint + 'oauth/token',
                    {
                        client_id: this.geoLocationClientID,
                        scope: '*',
                        client_secret: this.geoLocationSecret,
                        grant_type: 'client_credentials'
                    })
                    .then(response => {
                        this.geoLocationToken = response.data.access_token
                        this.checkUserLocation(location)
                    });
            },

            checkUserLocation(location) {
                //console.log('Check user location')
                //console.log(location)
                let newAxios = axios.create()
                newAxios.defaults.headers.common = {
                    'Authorization': 'Bearer ' + this.geoLocationToken,
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                }

                newAxios.get(this.geoLocationEndpoint + 'api/check-position',
                    {params: {customer_latitude: location.coords.latitude, customer_longitude: location.coords.longitude}})
                    .then(response => {
                        //console.log(response)
                        if (response.data.isInArea && response.data.isms_code) {
                            axios.get('/api/v1/checkLendingPoint/' + response.data.isms_code).then(resp => {
                                if (resp && resp.data && resp.data.id !== this.user.lending_point_id) {
                                    this.geoLocationLendingPoint = resp.data
                                    this.openGeoLocationModal()
                                }
                            })
                        }
                    });
            },

            openGeoLocationModal() {
                this.geolocationModal = true;
            },

            closeGeoLocationModal() {
                this.geolocationModal = false;
                this.updatePostLastSwitched()
            },

            updatePostLastSwitched() {
                axios.post(`${config.appUrl}/api/v1/set-lending-point`, {lendingPoint : this.user.lendingPoint})
            },

            setGeolocationLendingPoint() {
                axios.post(`${config.appUrl}/api/v1/set-lending-point`, {lendingPoint : this.geoLocationLendingPoint.id}).then(function() {
                    location.href = `${config.appUrl}/home?token=${this.token}`
                }.bind(this))
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/DropdownLendingPoint.vue